import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useSession } from '../session/useSession';

export function NotFound(): ReactNode {
    const { t } = useSession();

    return (
        <section className="card">
            <h1 className="card__title">{t('notFound.title')}</h1>
            <p className="card__body">{t('notFound.body')}</p>
            <Link className="button" to="/">
                {t('notFound.back')}
            </Link>
        </section>
    );
}
